import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
// import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import AddPreset from "./pages/admin/AddPreset";
import AddHotelInformation from "./pages/admin/AddHotelInformation";
import AdminLayout from "./components/AdminLayout";
import {
  ProtectedRoute,
  EmpProtectedRoute,
  KitchenProtectedRoute,
  PosProtectedRoute,
  MasterAdminRoute,
} from "./components/ProtectedRoute";
import Login from "./pages/admin/Login";
import MenuManagement from "./pages/admin/MenuManagement";
import Orders from "./pages/admin/Orders";
import LoyaltyPoints from "./pages/admin/LoyaltyPoints";
import POS from "./pages/pos/POS";
import Confirmation from "./pages/pos/Confirmation";
import TokenConfirmation from "./pages/pos/TokenConfirmation";
import AdminDashboard from "./pages/admin/AdminDashboard";
import Emplogin from "./Salespos/Emplogin";
import EmpRegister from "./pages/admin/EmpRegister";
import EmpPos from "./Salespos/EmpPos";
import EmpAllOrders from "./Salespos/EmpAllOrders";
import EmpManage from "./pages/admin/EmpManage";
import LocationAdminManagement from "./pages/admin/LocationAdminManagement";
import Discount from "./pages/admin/Discount";
import Choice from "./pages/pos/Choice";
import PayChoice from "./pages/pos/PayChoice";
import { OrderProvider } from "./pages/pos/OrderContext";
import CategoryManagement from "./pages/admin/CategoryManagement";
import ManageRoles from "./pages/admin/ManageRoles";
import Kitchenlogin from "./pages/kitchen/KitchenLogin";
import KitchenOrders from "./pages/kitchen/Kitchen";
import Notification from "./pages/kitchen/Notification";
import Setting from "./pages/kitchen/Setting";
import Support from "./pages/kitchen/Support";
import Poslogin from "./pages/pos/Poslogin";
import TaxManagement from "./pages/admin/TaxManage";
import { Toaster } from "react-hot-toast";
import Deals from "./pages/admin/Deals";
import PlatformLogo from "./pages/admin/PlatformLogo";
import PromotionalEmail from "./pages/admin/PromotionalEmail";
import RewardCampaigns from "./pages/admin/RewardCampaigns";
import DeveloperIntegrations from "./pages/admin/DeveloperIntegrations";
import { KitchenAuthProvider } from "./context/KitchenAuthContext";
import usePrintWebSocket from "./hooks/usePrintWebSocket";
import { useAuth } from "./context/AuthContext";
import SalesReport from "./pages/admin/reports/SalesReport";
import PaymentsReport from "./pages/admin/reports/PaymentsReport";
import ItemsReport from "./pages/admin/reports/ItemsReport";
import TaxReport from "./pages/admin/reports/TaxReport";
import Refunds from "./pages/admin/Refunds";
import Ledger, { WalletRechargePage } from "./pages/admin/Ledger";
import AdminBalancePage from "./pages/admin/AdminBalance";
import PageTitle from "./components/PageTitle";

const App: React.FC = () => {
  const { currencySymbol } = useAuth();
  usePrintWebSocket(currencySymbol);

  return (
    <OrderProvider>
      <KitchenAuthProvider>
        <Router>
          {/* <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          /> */}
          <Toaster position="top-center" reverseOrder={false} />
          <PageTitle />

          <Routes>
            {/* Pos Routes */}

            <Route path="/" element={<Poslogin />} />
            <Route
              element={
                <PosProtectedRoute>
                  <Outlet />
                </PosProtectedRoute>
              }
            >
              <Route path="choice" element={<Choice />} />
              <Route path="sos" element={<POS />} />
              <Route
                path="sos/confirmation/:orderId"
                element={<Confirmation />}
              />
              <Route
                path="sos/token-confirmation/:tempOrderId"
                element={<TokenConfirmation />}
              />
              <Route path="pay" element={<PayChoice />} />
            </Route>

            {/* Admin Routes */}
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Outlet />
                  </AdminLayout>
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="menu" element={<MenuManagement />} />
              <Route path="deals" element={<Deals />} />
              <Route path="orders" element={<Orders />} />
              <Route path="loyalty" element={<LoyaltyPoints />} />
              <Route path="category" element={<CategoryManagement />} />
              <Route
                path="managetax"
                element={<MasterAdminRoute><TaxManagement /></MasterAdminRoute>}
              />
              <Route path="register" element={<EmpRegister />} />
              <Route path="roles" element={<ManageRoles />} />
              <Route path="manage" element={<EmpManage />} />
              <Route path="location-admins" element={<LocationAdminManagement />} />
              <Route path="discount" element={<Discount />} />
              <Route
                path="addpreset"
                element={<MasterAdminRoute><AddPreset /></MasterAdminRoute>}
              />
              <Route
                path="addhotelinformation"
                element={<AddHotelInformation />}
              />
              <Route path="platform-logo" element={<PlatformLogo />} />
              <Route
                path="developer-integrations"
                element={<MasterAdminRoute><DeveloperIntegrations /></MasterAdminRoute>}
              />
              <Route
                path="promotional-email"
                element={<MasterAdminRoute><PromotionalEmail /></MasterAdminRoute>}
              />
              <Route
                path="reward-campaigns"
                element={<MasterAdminRoute><RewardCampaigns /></MasterAdminRoute>}
              />
              <Route path="refunds" element={<Refunds />} />
              <Route path="ledger" element={<Ledger />} />
              <Route path="ledger/wallet-recharges" element={<WalletRechargePage />} />
              <Route
                path="ledger/admin-balance"
                element={<MasterAdminRoute><AdminBalancePage /></MasterAdminRoute>}
              />
              <Route path="reports">
                <Route index element={<Navigate to="sales" replace />} />
                <Route path="sales" element={<SalesReport />} />
                <Route path="payments" element={<PaymentsReport />} />
                <Route path="items" element={<ItemsReport />} />
                <Route path="taxes" element={<TaxReport />} />
              </Route>
            </Route>

            {/* Salespos Routes */}
            <Route path="/login" element={<Emplogin />} />
            <Route
              path="/Sales"
              element={
                <EmpProtectedRoute>
                  <Outlet />
                </EmpProtectedRoute>
              }
            >
              <Route index element={<EmpPos />} />
              <Route path="all-orders" element={<EmpAllOrders />} />
            </Route>

            {/* Kitchen login */}
            <Route path="/kitchen/login" element={<Kitchenlogin />} />
            <Route
              path="/kitchen"
              element={
                <KitchenProtectedRoute>
                  <Outlet />
                </KitchenProtectedRoute>
              }
            >
              <Route index element={<KitchenOrders />} />
              <Route path="notification" element={<Notification />} />
              <Route path="setting" element={<Setting />} />
              <Route path="support" element={<Support />} />
            </Route>
          </Routes>
        </Router>
      </KitchenAuthProvider>
    </OrderProvider>
  );
};

export default App;
